import { HotelInitial, ViewLodging, TripLodging } from "@/types";
import { useQueryClient } from "@tanstack/react-query";

export const convertHotelIntoViewLodging = (
  hotel: HotelInitial
): ViewLodging => {
  const tripLodging: ViewLodging = {
    id: hotel.hotelId,
    name: hotel.hotelName,
    type: "hotel",
    description: "",
    mainImageURL: hotel.imageURL,
    latitude: hotel.latitude,
    longitude: hotel.longitude,
    moreInfo: {
      reviewScore: hotel.reviewScore,
      reviewCount: hotel.reviewCount,
    },
  };

  return tripLodging;
};

export const useFindHotelInitialById = (hotelId: string) => {
  const queryClient = useQueryClient();
  const hotelInitial = queryClient.getQueryData<HotelInitial>([
    "hotels",
    hotelId,
  ]);
  return hotelInitial;
};
